import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import CMSService from 'services/CMS';
import PubSub from "services/PubSub";
import TagManagerService from 'services/TagManager';
import Link from 'components/Link';
import ImageLoad from 'components/ImageLoad';
import Countdown from 'components/Home/BannerTimer/Countdown';
import style from './style.scss';//NOSONAR

let action = [];

const BannerTimer =  (props) => {
    const data = props.data;
    if(!data) return false;
    if (!data.active) return false;
    const serverDate = props.dateServer;
    const [visible, setVisible] = useState(false);
    let url = data.url ? data.url : '';
    let target = data.target ? data.target : '';
    let title = data.title ? data.title : '';
    let timerId = "banner-timer" +  data.countBannerTimer;
    
    useEffect(() => {
        const validateDate = CMSService.validDatesItem(data, serverDate);

        if(validateDate) {
            setVisible(validateDate);
        }
    },[]);

    useEffect(() => {
        action.push(PubSub.register('banner-timer-show', showBannertimer));

        return function cleanup() {
            action.map(token => PubSub.unregister(token));
            action = [];
        }
    }, []);

    const showBannertimer = (payload) => {
        if(payload && payload.value.timerId === timerId) {
            setVisible(false);
        }
    }

    let imageResponsive = {
        840: data.image_mobile ? data.image_mobile : '',
        1440: data.image_desktop ? data.image_desktop : ''
    };

    let bannerTimerAlt = data.title || data.image_desktop;

    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        data.id = data.image_mobile ? data.image_mobile.split('/').pop() : '';
    } else {
        data.id = data.image_desktop  ? data.image_desktop.split('/').pop() : '';
    }

    const promotionsClick = (info) => {
        info.title = info.title || info.id;
        info.url_banner = info.url;
        TagManagerService.promotionsClick( info, 'slot' + info.countBannerTimer, 'Banner-Timer '+ info.countBannerTimer );  
    }

    let gtmData = {
        id: data.id,
        name: data.title ? data.title : data.id,
        creative: `Banner Timer ${data.countBannerTimer}`,
        position: `slot${data.countBannerTimer}`,
        type: 'banner-timer',
    }

    return (
        <>
            {visible && (
                <div className="banner-timer-container">
                    <h1 className="banner-timer-title">{title}</h1>
                    <div className="banner-timer-count-image">
                        <Link to={url} target={target} onClick={() => promotionsClick(data)} className="banner-timer-link">
                            <div className="banner-timer-countdown">
                                <Countdown dateEnd={data.end_date} serverDate={serverDate} timerId={timerId} color={data.color_light}/>
                            </div>
                            <div className="banner-timer-image">
                                <ImageLoad src={data.image_desktop} srcSet={imageResponsive} alt={bannerTimerAlt} gtmData={gtmData} />
                            </div>
                        </Link>
                    </div>
                </div>
            )}
        </>
    )
}

BannerTimer.propTypes = {
    data: PropTypes.object,
    dateServer: PropTypes.number
};

export default BannerTimer;
